import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import React, { Component } from "react";
const containerStyle = {
    position: "relative",
    width: "100%",
    height: "calc(100% - 85px)",
    minHeight: 230
};

class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lat: 0,
            lng: 0,
            markerName: "",
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {}
        };
    }

    onMarkerClick = (props, marker, e) => {
        this.onMarkerChange();
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    };

    onMapClicked = props => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };
    render() {
        const lat = isNaN(+this.props.lat) ? false : +this.props.lat;
        const lng = isNaN(+this.props.long) ? false : +this.props.long;

        if (lat === false || lng === false) {
            return null;
        } else {
            return (
                <Map
                    style={{ border: "1px solid rgb(195, 207, 214)" }}
                    google={this.props.google}
                    initialCenter={{ lat, lng }}
                    zoom={9}
                    // onClick={this.onMarkerClick}
                    containerStyle={containerStyle}
                    onClick={(e, t, v) => {
                        // this.props.action(e, t, v);
                        this.onMapClicked();
                    }}
                >
                    <Marker
                        position={{ lat: lat, lng: lng }}
                        name={this.state.markerName}
                        onClick={this.onMarkerClick}
                        onChange={this.onMarkerChange}
                    />
                    <InfoWindow
                        marker={this.state.activeMarker}
                        visible={this.state.showingInfoWindow}
                    >
                        <div>
                            <p>{this.state.markerName}</p>
                        </div>
                    </InfoWindow>
                </Map>
            );
        }
    }
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyD2s9vyxwQCR8y7F8pCGFgAvJFJ8inhRTU"
})(MapContainer);
